import React, { useState, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import HomeUserWayAccessibilityMenu from "../HomeUserWayAccessibilityMenu/homeUserWayAccessibility";
import RigVedQuotes from "../HomeRigvedQuotes/rigvedQuotes";
import AngelAiHeader from "../AngelAiHeader/AngelAiHeader";

import "../HomeHeader/homeheader.css";
import "../LoHeader/LoHeader.css";
import "../InfluencerHeader/InfluencerHeader.css";

const isAngelAi = process.env.REACT_APP_DOMAIN === "angelai";

const HEADER_CONFIG = {
  main: {
    navbarId: "menuNavbar",
    navbarClass: "navbar",
    logoClass: "main_logo img-fluid",
    angelaiLogoClass: "angelai-logo",
    taglineContainerClass: "tagline-container",
    taglineClass: "brand-tagline",
    angelaiContainerClass: "angelai-section",
    headerRightClass: "header-right-section",
    AccessibilityMenu: HomeUserWayAccessibilityMenu,
    useHeaderRightLayout: true,
  },
  // mlo/influencer reuse the main header's own JSX branch and CSS classes
  // (main_logo / angelai-logo / tagline-container / brand-tagline /
  // angelai-section / header-right-section, all from homeheader.css)
  // instead of a second, independently-maintained implementation. That
  // second implementation (its own absolute-positioned logo/tagline, its own
  // per-breakpoint pixel offsets) is what produced this session's whole chain
  // of bugs - every value had to be independently re-derived and kept
  // in sync with main's, and several transcription slips (a misplaced CSS
  // variable, a stale duplicate rule) crept in along the way. Sharing the
  // actual rules means mlo/influencer get every future main-header fix for
  // free, with nothing to keep in sync by hand.
  // navbarId/navbarClass stay per-type (background colour, active state);
  // AccessibilityMenu stays per-type (a different component entirely).
  mlo: {
    navbarId: "loanOfficerNavbar",
    navbarClass: "loanOfficerNavbar",
    logoClass: "main_logo img-fluid",
    angelaiLogoClass: "angelai-logo",
    taglineContainerClass: "tagline-container",
    taglineClass: "brand-tagline",
    angelaiContainerClass: "angelai-section",
    headerRightClass: "header-right-section",
    AccessibilityMenu: UserWayAccessibilityMenu,
    useHeaderRightLayout: true,
  },
  influencer: {
    navbarId: "influencerNavbar",
    navbarClass: "influencerNavbar",
    logoClass: "main_logo img-fluid",
    angelaiLogoClass: "angelai-logo",
    taglineContainerClass: "tagline-container",
    taglineClass: "brand-tagline",
    angelaiContainerClass: "angelai-section",
    headerRightClass: "header-right-section",
    AccessibilityMenu: UserWayAccessibilityMenu,
    useHeaderRightLayout: true,
  },
};

const MastermindsHeader = ({ pageType = "main" }) => {
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  const config = HEADER_CONFIG[pageType] || HEADER_CONFIG.main;
  const AccessibilityMenu = config.AccessibilityMenu;

  useEffect(() => {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const menuNavbar = document.getElementById(config.navbarId);

      if (currentScrollPos === 0) {
        menuNavbar?.classList.remove("navbarTransition");
        setNavbar(false);
      } else if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar?.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [config.navbarId, isMobileOrTabletDevice]);

  if (isAngelAi) return <AngelAiHeader />;

  const logoSection = (
    <a href="https://www.swmc.com/" target="_blank" rel="noopener noreferrer" title="Sun West Mortgage Logo">
      <img
        src={`${process.env.REACT_APP_CDN_LINK}swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg`}
        className={config.logoClass}
        alt="Sun West Logo"
      />
    </a>
  );

  const angelaiLogo = (
    <img
      src={`${process.env.REACT_APP_CDN_LINK}angel-ai/latest-angelai-logo-new.webp`}
      className={config.angelaiLogoClass}
      alt="AngelAi Logo"
    />
  );

  const tagline = (
    <div className={config.taglineContainerClass}>
      <p
        className={config.taglineClass}
        onClick={() => setShowRigVedQuotes(true)}
        onMouseOver={() => setShowRigVedQuotes(true)}
        onMouseOut={() => setShowRigVedQuotes(false)}
      >
        Nothing Is Beyond Reach
      </p>
      <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
    </div>
  );

  if (config.useHeaderRightLayout) {
    return (
      <div>
        <Navbar
          id={config.navbarId} collapseOnSelect expand="lg" fixed="top" bg="dark" variant="dark"
          className={navbar ? `${config.navbarClass} active` : config.navbarClass}
        >
          <Navbar.Brand>{logoSection}</Navbar.Brand>
          <div className={config.headerRightClass}>
            <div className={config.angelaiContainerClass}>
              <a href="https://www.angelai.com/" target="_blank" rel="noopener noreferrer">{angelaiLogo}</a>
              {tagline}
            </div>
            <AccessibilityMenu color="white" width={40} height={40} />
          </div>
        </Navbar>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        id={config.navbarId} collapseOnSelect expand="lg" fixed="top" bg="dark" variant="dark"
        className={navbar ? `${config.navbarClass} active` : config.navbarClass}
      >
        <Navbar.Brand className="ps-3">
          <div className="d-flex"><div>{logoSection}</div></div>
        </Navbar.Brand>
        {/* The lockup and the accessibility icon (desktop or mobile - only one
            is ever visible, toggled by display:none in CSS at each breakpoint)
            are flex siblings in one row, the same way the main header pairs
            .angelai-section with its AccessibilityMenu inside
            .header-right-section: a `gap` keeps them apart naturally at any
            width, instead of each floating via its own independent
            `position:absolute` (which is what let the lockup overlap the icon
            once it was pushed flush to the navbar's edge - true at both the
            desktop and the mobile icon, since both used to sit outside this
            row). The lockup itself still centres against Navbar.Brand via the
            navbar's own align-items:center, since this row is a plain flex
            child of the navbar too. This branch only renders for the
            MLO/influencer headers (config.useHeaderRightLayout is false
            here); the main header returns from the branch above and never
            reaches this JSX. */}
        <div className="angelai-header-right">
          <div className="angelai-lockup">
            <a href="https://www.angelai.com/" target="_blank" rel="noopener noreferrer" className={config.angelaiContainerClass}>
              {angelaiLogo}
            </a>
            {tagline}
          </div>
          <div className="desktop-AccessibilityMenu-show1">
            <AccessibilityMenu color="white" width={40} height={40} />
          </div>
          <div className="mobile-AccessibilityMenu-show1">
            <AccessibilityMenu color="white" width={40} height={40} />
          </div>
        </div>
      </Navbar>
    </div>
  );
};

export default MastermindsHeader;
